import React from "react";
import { MessageCircle } from "lucide-react";
import { trackEvent } from "../lib/analytics";

const PHONE = "447704885084"; // UK +44 07704885084
const DEFAULT_MESSAGE = "Hi Oxford Environmental Consultants, I'd like to enquire about your compliance services.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with OEC on WhatsApp"
      data-testid="whatsapp-float"
      onClick={() => trackEvent("contact_whatsapp", { location: "floating_button" })}
      className="fixed bottom-6 right-6 z-[60] group flex items-center gap-3 bg-[#25D366] hover:bg-[#1ea954] text-white pl-4 pr-5 py-3 rounded-full shadow-lg shadow-black/20 hover:shadow-xl transition-all hover:-translate-y-0.5"
    >
      <span className="relative flex items-center justify-center w-8 h-8">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true" className="relative">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.966-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.298-1.04 1.016-1.04 2.479s1.065 2.876 1.213 3.074c.149.198 2.097 3.202 5.08 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.304-1.654a11.882 11.882 0 005.688 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </span>
      <span className="hidden sm:inline text-sm font-semibold tracking-wide">WhatsApp us</span>
    </a>
  );
}
